import { apiFetch } from './client';

export interface ContactRow {
  id: string;
  reseller_id: string;
  customer_id: string;
  /** Per-customer sequential number, displayed as `CT-{N}`. */
  ref_number: number;
  display_name: string;
  /** CID number presented on the called leg for internal dials. */
  internal_cid_phone: string | null;
  /** Public/external phone for click-to-call. */
  external_phone: string | null;
  email: string | null;
  notes: string | null;
  active: boolean;
  created_at: string;
  updated_at: string;
  deleted_at: string | null;
}

interface CreateContactBody {
  display_name: string;
  internal_cid_phone?: string | null;
  external_phone?: string | null;
  email?: string | null;
  notes?: string | null;
  active?: boolean;
  customer_id?: string;
}

type UpdateContactBody = Partial<
  Pick<ContactRow,
    | 'display_name'
    | 'internal_cid_phone'
    | 'external_phone'
    | 'email'
    | 'notes'
    | 'active'
  >
>;

export const contacts = {
  list: (params: {
    customer_id?: string;
    search?: string;
    active_only?: boolean;
    limit?: number;
  } = {}) => {
    const q = new URLSearchParams();
    if (params.customer_id) q.set('customer_id', params.customer_id);
    if (params.search) q.set('search', params.search);
    if (params.active_only) q.set('active', 'true');
    if (params.limit) q.set('limit', String(params.limit));
    return apiFetch<{ rows: ContactRow[] }>(`/api/contacts?${q}`);
  },
  get: (idOrRef: string, customerId?: string | null) => {
    const q = new URLSearchParams();
    if (customerId) q.set('customer_id', customerId);
    const qs = q.toString();
    return apiFetch<ContactRow>(`/api/contacts/${idOrRef}${qs ? `?${qs}` : ''}`);
  },
  create: (body: CreateContactBody) =>
    apiFetch<ContactRow>('/api/contacts', {
      method: 'POST',
      body: JSON.stringify(body),
    }),
  update: (id: string, body: UpdateContactBody) =>
    apiFetch<ContactRow>(`/api/contacts/${id}`, {
      method: 'PATCH',
      body: JSON.stringify(body),
    }),
  remove: (id: string) =>
    apiFetch<void>(`/api/contacts/${id}`, { method: 'DELETE' }),
};
